module.exports = __webpack_public_path__ + "img/scope.c93ec5d3.svg";